<template>
<div>
  <div class="frameBg" v-show="showModal2"></div>
    <div class="frameInput" style="margin-top:-356px;" v-show="batteryBox">
        <div class="frameHead indexHead clear">
          <p class="l">How to distinguish battery type</p><p @click="getClose" class="r" style="font-size:26px;">×</p>
        </div>
        <div class="content">
          <img src="../../../assets/img/batterytype.png" width="660" />
        </div>
        <div class="framePwBtn">
              <a style="margin-left:40%;" class="sureA l" @click="getClose">OK</a>
          </div>  
      </div>
</div>
     
</template>
<script>
  export default {
    props: {
      titNames:'',
      titUrls:''
    },
    data () {
      return {
        showModal2:false,
        batteryBox:false,
      }
    },
    mounted:function(){
    },

    methods:{
      getClose(){ //关闭弹框
        this.showModal2=false
        this.batteryBox=false
      },
      //打开弹框
      clkOpenBox(){
        this.showModal2=true
        this.batteryBox=true
      },
    }

  }
</script>
<style lang="css" scoped>
  @import "../../../assets/css/frame.css";
  .frameInput .content label{margin:0 10px}
  .frameInput .content label h3{margin-bottom:5px;}
  .frameInput .content label p{color:#666;font-size:12px;}
</style>



// WEBPACK FOOTER //
// src/components/userCenter/public/batteryType.vue